var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "profile container-fluid" }, [
    _vm.$userIsAdmin
      ? _c(
          "button",
          {
            staticClass: "profile__back btn btn-info",
            on: {
              click: function ($event) {
                return _vm.$router.push("/talent")
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-chevron-left" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "Back to " +
                  _vm._s(_vm._f("sentenceCase")(_vm.$starLabel)) +
                  " List"
              ),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "profile__header" }, [
      _c("div", { staticClass: "profile__image" }, [
        _c("img", {
          attrs: { src: _vm.user.profile_image_url, alt: _vm.user.name },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "profile__text" }, [
        _c("h1", [_vm._v(_vm._s(_vm.user.name))]),
        _vm._v(" "),
        _c("div", { staticClass: "profile__tagline" }, [
          _vm._v("\n        " + _vm._s(_vm.user.profile.tagline) + "\n      "),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "profile__buttons" },
          [
            _c(
              "ladda-button",
              {
                staticClass: "btn btn-primary",
                attrs: { button: "", click: _vm.handleDownloadPdfCallback },
              },
              [
                _c("i", { staticClass: "fa fa-cloud-download" }),
                _vm._v(" Download Bio\n        "),
              ]
            ),
            _vm._v(" "),
            _vm.canEdit
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: {
                      tag: "button",
                      to: {
                        name: "talent.profile.show",
                        params: { id: _vm.user.id, status: "event" },
                      },
                    },
                  },
                  [_vm._v("\n            Edit profile\n          ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "profile__body" }, [
      _c("div", { staticClass: "profile__section" }, [
        _c("h2", [_vm._v("About me")]),
        _vm._v(" "),
        _c("div", {
          domProps: { innerHTML: _vm._s(_vm.user.profile.description) },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "profile__section" }, [
        _c("div", { staticClass: "profile__row" }, [
          _c("div", { staticClass: "profile__column" }, [
            _c("h2", [_vm._v("Based in")]),
            _vm._v(" "),
            _vm.userBased
              ? _c("ul", { staticClass: "tags" }, [
                  _c("li", [
                    _c("span", { staticClass: "tag" }, [
                      _vm._v(_vm._s(_vm.user.based_in.name)),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "profile__column" }, [
            _c("h2", [_vm._v("Available in")]),
            _vm._v(" "),
            _vm.user.locations
              ? _c(
                  "ul",
                  { staticClass: "tags" },
                  _vm._l(_vm.user.locations_names, function (location) {
                    return _c("li", { key: location.id }, [
                      _c("span", { staticClass: "tag" }, [
                        _vm._v(_vm._s(location.name)),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.user.custom_fields && _vm.user.custom_fields.length
        ? _c("div", { staticClass: "profile__section" }, [
            _c("div", { staticClass: "profile__row" }, [
              _c("div", { staticClass: "profile__column" }, [
                _c("h2", [_vm._v("Custom Data")]),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.user.custom_fields, function (field) {
                    return _c("li", { key: field.field }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(field.name) +
                          ": " +
                          _vm._s(field.value) +
                          "\n            "
                      ),
                    ])
                  }),
                  0
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "profile__section" }, [
        _c("h2", [_vm._v("Protected sponsors")]),
        _vm._v(" "),
        _vm.sponsors
          ? _c(
              "ul",
              { staticClass: "tags" },
              _vm._l(_vm.sponsors, function (sponsor) {
                return _c("li", { key: sponsor.id }, [
                  _c("span", { staticClass: "tag" }, [
                    _vm._v(_vm._s(sponsor.name)),
                  ]),
                ])
              }),
              0
            )
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }